import { usePlaysoutAPI } from '../hooks/usePlaysoutAPI';

/**
 * Playsout 认证提供者
 * 在应用根部使用，处理登录状态和loading显示
 */
export function PlaysoutAuthProvider({ children }: { children: React.ReactNode }) {
  const { isLoggingIn } = usePlaysoutAPI();

  return (
    <>
      {children}
      
      {/* Login Loading Overlay */}
      {isLoggingIn && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[9999] flex items-center justify-center">
          <div className="bg-game-card rounded-2xl p-8 flex flex-col items-center gap-4 shadow-2xl border border-gray-700">
            {/* Spinning Loader */}
            <div className="relative">
              <div className="w-16 h-16 border-4 border-gray-600 border-t-game-accent rounded-full animate-spin"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <svg className="w-8 h-8 text-game-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
            </div>
            
            {/* Text */}
            <div className="text-center">
              <h3 className="text-white text-lg font-semibold mb-1">Signing In</h3>
              <p className="text-gray-400 text-sm">Please sign the message in your wallet</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
